import FadeInSection from '../../../components/feature/FadeInSection';

const planItems = [
  { label: '入会金', price: '110,000円', note: '税込み・初回のみ' },
  { label: '月会費', price: '11,000円', note: '税込み・毎月' },
  { label: 'お見合い費', price: '0円', note: '何度でも無料' },
  { label: '成婚料', price: '250,000円', note: '税込み・成婚時のみ' },
];

const features = [
  '専任カウンセラーによる個別サポート',
  '無制限のプロフィール閲覧',
  'お見合いセッティングサポート（何度でも無料）',
  '交際サポート・アドバイス',
  '成婚後のフォローアップ',
];

const notes = [
  '記載の料金はすべて税込み価格です。',
  '入会金は一度のみ発生します。月会費は毎月お支払いいただきます。',
  'お見合い費は何度でも無料です。気軽にお見合いを重ねていただけます。',
  '成婚料は成婚が決まった際にご請求いたします。',
  '料金は予告なく変更となる場合がございます。最新情報はお問い合わせください。',
  '退会後の返金は一切対応いたしておりません。',
];

export default function PriceTableSection() {
  return (
    <section className="section-padding" style={{ background: '#fff8f2' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#8b4513', color: '#fff' }}
          >
            料金一覧
          </p>
          <h2 style={{ color: '#4a3728' }}>入会から成婚まで、安心の料金体系</h2>
          <p style={{ color: '#6b5a4e', marginTop: '12px', fontSize: '17px' }}>
            シンプルでわかりやすい、1つのプランをご用意しています
          </p>
        </FadeInSection>

        {/* Single plan card */}
        <FadeInSection className="mb-14">
          <div
            className="max-w-2xl mx-auto rounded-2xl overflow-hidden"
            style={{ border: '2px solid #e8934e' }}
          >
            {/* Header */}
            <div className="p-8 text-center" style={{ background: '#8b4513' }}>
              <span className="flex items-center justify-center w-14 h-14 mx-auto mb-4">
                <i className="ri-heart-fill text-white text-4xl"></i>
              </span>
              <h3 className="text-white mb-1" style={{ fontSize: '24px', fontWeight: '700' }}>
                ベーシックプラン
              </h3>
              <p className="text-white/80 text-sm">真剣に人生のパートナーをお探しの方へ</p>
            </div>

            {/* Price items */}
            <div className="p-8 md:p-10" style={{ background: '#fff8f2' }}>
              <table className="w-full mb-10">
                <tbody>
                  {planItems.map((item, i) => (
                    <tr
                      key={i}
                      style={{
                        borderBottom: i < planItems.length - 1 ? '1px solid #e8d8cc' : 'none',
                      }}
                    >
                      <td
                        className="py-5"
                        style={{ color: '#4a3728', fontSize: '17px', fontWeight: '600' }}
                      >
                        {item.label}
                      </td>
                      <td className="py-5 text-right">
                        <span style={{ color: '#8b4513', fontSize: '22px', fontWeight: '700' }}>
                          {item.price}
                        </span>
                        <span
                          className="block"
                          style={{ color: '#6b5a4e', fontSize: '13px', marginTop: '2px' }}
                        >
                          {item.note}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Features */}
              <div className="rounded-xl p-6" style={{ background: '#fff' }}>
                <p className="font-bold mb-4" style={{ color: '#4a3728', fontSize: '15px' }}>
                  含まれるサービス
                </p>
                <ul className="space-y-3">
                  {features.map((f, i) => (
                    <li key={i} className="flex items-center gap-3">
                      <span className="flex items-center justify-center w-5 h-5 shrink-0">
                        <i className="ri-check-line text-[#e8934e] text-lg"></i>
                      </span>
                      <span style={{ color: '#4a3728', fontSize: '15px' }}>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </FadeInSection>

        {/* Cost summary */}
        <FadeInSection className="mb-14">
          <div
            className="rounded-2xl p-8 md:p-10"
            style={{ background: '#fff', border: '1px solid #e8d8cc' }}
          >
            <h3
              className="text-center mb-8"
              style={{ color: '#4a3728', fontSize: '22px', fontWeight: '700' }}
            >
              費用の目安
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-dashed divide-[#e8d8cc]">
              <div className="text-center p-6">
                <p
                  className="mb-2 text-sm font-bold uppercase tracking-wider"
                  style={{ color: '#8b4513' }}
                >
                  初期費用
                </p>
                <p style={{ color: '#4a3728', fontSize: '28px', fontWeight: '700' }}>
                  110,000<span style={{ fontSize: '16px' }}>円</span>
                </p>
                <p style={{ color: '#6b5a4e', fontSize: '13px', marginTop: '4px' }}>
                  入会金（税込み）
                </p>
              </div>
              <div className="text-center p-6">
                <p
                  className="mb-2 text-sm font-bold uppercase tracking-wider"
                  style={{ color: '#8b4513' }}
                >
                  月額費用
                </p>
                <p style={{ color: '#4a3728', fontSize: '28px', fontWeight: '700' }}>
                  11,000<span style={{ fontSize: '16px' }}>円</span>
                </p>
                <p style={{ color: '#6b5a4e', fontSize: '13px', marginTop: '4px' }}>
                  月会費（税込み）
                </p>
              </div>
              <div className="text-center p-6">
                <p
                  className="mb-2 text-sm font-bold uppercase tracking-wider"
                  style={{ color: '#8b4513' }}
                >
                  成婚時費用
                </p>
                <p style={{ color: '#4a3728', fontSize: '28px', fontWeight: '700' }}>
                  250,000<span style={{ fontSize: '16px' }}>円</span>
                </p>
                <p style={{ color: '#6b5a4e', fontSize: '13px', marginTop: '4px' }}>
                  成婚料（税込み）
                </p>
              </div>
            </div>
            <div
              className="mt-8 rounded-xl p-5 text-center"
              style={{ background: '#fff8f2' }}
            >
              <p style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.9' }}>
                例：<strong style={{ color: '#8b4513' }}>6ヶ月間の活動費用目安</strong>
                ：入会金110,000円 ＋ 月会費11,000円×6ヶ月 ＝
                <strong style={{ color: '#8b4513' }}> 約176,000円（税込み）</strong>
                <br />
                成婚された場合、別途成婚料250,000円（税込み）が発生します
              </p>
            </div>
          </div>
        </FadeInSection>

        {/* Notes */}
        <FadeInSection>
          <div
            className="rounded-2xl p-8"
            style={{ background: '#fff', border: '1px solid #e8d8cc' }}
          >
            <h3
              className="mb-5"
              style={{ color: '#4a3728', fontSize: '18px', fontWeight: '700' }}
            >
              ご注意事項
            </h3>
            <ul className="space-y-3">
              {notes.map((note, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="flex items-center justify-center w-5 h-5 shrink-0 mt-0.5">
                    <i className="ri-information-line text-[#8b4513] text-base"></i>
                  </span>
                  <span style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.7' }}>
                    {note}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
